import { faPlus } from "@fortawesome/free-solid-svg-icons";
import Page, { PageActionsType } from "components/common/page/Page"
import RoomTypeDatalist from "components/entities/accommodation/roomType/RoomTypeDatalist";
import { AppRoutes } from "config/router";
import { Roles } from "utilities/app-utilities";
import useAppContext from "utilities/hooks/useAppContext";

const RoomTypeDatalistPage = () => {
    const context = useAppContext();

    const pageActions: PageActionsType = [
        {
            icon: faPlus,
            name: 'add',
            title: 'button.add',
            link: AppRoutes.ACCOMMODATION_ROOM_TYPE_FORM,
            hide: !context.userHasRole(Roles.ADMIN)
        }
    ]

    return (
        <Page wFull title="pages.accommodation.roomType.list" actions={pageActions}>
            <RoomTypeDatalist name="pages-accommodation-room-list" />
        </Page>
    );
};

export default RoomTypeDatalistPage;
